import React from "react";
import { dirCondition } from "../inputsAlgorithms";
const CheckBox = ({
  containerStyle,
  onChange,
  value,
  checked,
  name,
  color,
  require,
  required,
  id,
}) => {
  return (
    <div
      className={`${containerStyle} d-flex align-items-start`}
      style={{ fontSize: 16 }}
    >
      <label
        style={{ cursor: "pointer", borderColor: color }}
        htmlFor={id}
        className={`checkbox  ${dirCondition("checkbox")}  `}
      >
        <input
          name={name}
          id={id}
          type={"checkbox"}
          checked={checked}
          value={value}
          onChange={onChange}
          required={required}
        ></input>
        <span className="primary"></span>
      </label>
      <span
        className="d-flex align-items-center"
        style={{ color: color, margin: 2 }}
      >
        {checked ? null : require ? "*" : null}
      </span>
    </div>
  );
};

export default CheckBox;
